<script>
    import { onDestroy } from 'svelte';

    // subscribe to store, get tags etc etc
    import feedStore from '../../stores/feed';
    import * as storeHelpers from '../../stores/helpers';
    import { sortTags } from '../../services/bestCommunities';
    import SmallScreenItemContainer from '../SmallScreenItemContainer/index.svelte';
    export let displayItems;
    export let handleManageItemAction;
    export let handleFilterAction;
    let tagCommunities = [];
    let tagCommunity = [];
    let sorted = {};
    let innerWidth;

    export let feedToDisplay;

    // $: tagCommunity = tagCommunities.length && tagCommunities[0];
    // $: {
    //     if (tagCommunities.length) {
    //         tagCommunity = tagCommunities[0];
    //     }
    // }

    const unsubscribe = feedStore.subscribe(value => {
        tagCommunities = value.tagCommunities;
        // if (tagCommunities.length) {
            // add a loaded class to tag-communities-container-inner
            // document.querySelector('#tag-communities-container').classList.add('loaded')

        // }
        sorted = sortTags(value.itemTagsMap);
    });
    $: communitiesExistingAndLoaded = tagCommunities.length;

    function handleCloudClick(event) {
        const { target } = event;
        const { cloudIdx, tag } = target.dataset;
        const tags = tagCommunities[cloudIdx];
        const items = storeHelpers.queryItemsWithTags(tags);
        
        displayItems(items, tag);
    }
    function mobileHandleCloudClick(event) {
        const { target } = event;
        const { cloudIdx, tag } = target.dataset;

        // multiply cloudIdx with the screen width to figure out how far to scroll
        const elToScroll = document.getElementsByClassName('inner')[0];
        elToScroll.scrollLeft = (parseInt(cloudIdx) + 2) * innerWidth;

        _handleFinalSection();
    }
    let currentCloudIdxAfterSwipe = 0;
    let pinnedItemIds = [];
    function handleBottomNavClick(event) {
        const { target } = event;
        const { tag } = target.dataset;
        const itemIds = storeHelpers.getItemIdsWithTags([tag]);
        pinnedItemIds = itemIds.flat();
        window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
    }

    function _handleFinalSection() {
        setTimeout(() => {
            const section = Array.from(document.querySelectorAll('.section')).find(el => {
                return el.getBoundingClientRect().x > 0;
            });

            const idx = section.dataset.cloudIdx;
            if (!idx || !parseInt(idx)) {
                tagCommunity = [];
            } else {
                tagCommunity = tagCommunities[idx];
            }
            if (currentCloudIdxAfterSwipe !== idx) {
                // swiped to a new section
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
                currentCloudIdxAfterSwipe = idx;
                pinnedItemIds = [];
            }			
		}, 400)
    }

    function handleTouchEnd(event) {
       _handleFinalSection();
    }

    onDestroy(unsubscribe);
</script>

<svelte:window bind:innerWidth={innerWidth}/>

{#if tagCommunities.length === 0}
    <div id="tag-communities-container"></div>
{:else}
    <div id="tag-communities-container" class="{communitiesExistingAndLoaded ? 'loaded' : ''}">
        <div style="" id="tag-communities-container-inner">
            {#each tagCommunities as comm, cloudIdx}
                <div style="cursor: pointer;" on:click="{handleCloudClick}">
                    <ul class="cloud" data-cloud-idx="{cloudIdx}">
                        {#each comm as tag}
                            <li
                                data-weight="{Math.round((100-(sorted[tag]?.idx || 0))/10) || 1}"
                                data-cloud-idx="{cloudIdx}"
                                data-tag="{tag}"
                            >
                                {tag.slice(1)}
                            </li>
                        {/each}
                    </ul>
                </div>
            {/each}
        </div>
    </div>

    <div class="items-container-sm-screen"
			on:touchend={handleTouchEnd}
		>
			<div class="inner">
                <div class="section section-id-allItems" data-cloud-idx="allItems">
                    <SmallScreenItemContainer
                        items={feedToDisplay}
                        pinnedItemIds={[]}
                        handleManageItemAction={handleManageItemAction}
                        handleFilterAction={handleFilterAction}
                    />
                </div>
                <div class="section section-id-tagcommunities" data-cloud-idx="allTags">
                    {#each tagCommunities as comm, cloudIdx}
                        <div style="cursor: pointer;" on:click="{mobileHandleCloudClick}">
                            <ul class="cloud" data-cloud-idx="{cloudIdx}">
                                {#each comm as tag}
                                    <li
                                        data-weight="{Math.round((100-(sorted[tag]?.idx || 0))/10) || 1}"
                                        data-cloud-idx="{cloudIdx}"
                                        data-tag="{tag}"
                                    >
                                        {tag.slice(1)}
                                    </li>
                                {/each}
                            </ul>
                        </div>
                    {/each}
                </div>
				{#each tagCommunities as comm, cloudIdx}
					<div class="section section-id-{cloudIdx}" data-cloud-idx="{cloudIdx}">
                        <SmallScreenItemContainer
                            items={storeHelpers.queryItemsWithTags(comm)}
                            pinnedItemIds={pinnedItemIds}
                            handleManageItemAction={handleManageItemAction}
                            handleFilterAction={handleFilterAction}
                        />
                    </div>
                {/each}
            </div>
    </div>

    <div class="feed-bottom-nav">
        <div class="feed-bottom-nav-inner">
            <ul class="bottom-nav-cloud">
                {#each tagCommunity as tag}
                    <li on:click="{handleBottomNavClick}"
                        data-weight="{Math.round((100-(sorted[tag]?.idx || 0))/10) || 1}"
                        data-tag="{tag}"
                    >
                        {tag.slice(1)}
                    </li>
                {/each}
            </ul>
        </div>
    </div>
{/if}

<style>
    .items-container-sm-screen {
        display: none;
    }
    #tag-communities-container {
        width: 40%;
        opacity: 0;

        -webkit-transition: opacity 1s ease-in;
        -moz-transition: opacity 1s ease-in;
            -ms-transition: opacity 1s ease-in;
            -o-transition: opacity 1s ease-in;
                transition: opacity 1s ease-in;
    }
    #tag-communities-container-inner {
        overflow-y:scroll;
        position:fixed;
        top: 150px;
        bottom: 0;
        width: 30%;
    }
    #tag-communities-container-inner::-webkit-scrollbar {
        display: none;
    }
    #tag-communities-container-inner {
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
    }
    #tag-communities-container.loaded {
        opacity: 1 !important;
    }
    .cloud {
		list-style: none;
		padding-left: 0;
		display: flex;
		flex-wrap: wrap;
		line-height: 2rem;
		background: rgb(0,0,0);
		padding: 10px;
		border-radius: 6px;
	}
	ul.cloud li {
		color: #2a7e19;
		display: block;
		font-size: 1rem;
		padding: 0.125rem 0.25rem;
		text-decoration: none;
		position: relative;
		--size: 4;
		/* font-size: calc(var(--size) * 0.25rem + 0.5rem); */
		opacity: calc((15 - (9 - var(--size))) / 15); 
	}
	ul.cloud li[data-weight="1"] { --size: 1; }
	ul.cloud li[data-weight="2"] { --size: 2; }
	ul.cloud li[data-weight="3"] { --size: 3; }
	ul.cloud li[data-weight="4"] { --size: 4; }
	ul.cloud li[data-weight="5"] { --size: 5; }
	ul.cloud li[data-weight="6"] { --size: 6; }
	ul.cloud li[data-weight="7"] { --size: 7; }
	ul.cloud li[data-weight="8"] { --size: 8; }
	ul.cloud li[data-weight="9"] { --size: 9; }

    .feed-bottom-nav {
		display: none;
	}
    @media (max-width: 640px) {
		/* .page-container {
			display: block;
		} */
        ul.bottom-nav-cloud li[data-weight="1"] { --size: 1; }
        ul.bottom-nav-cloud li[data-weight="2"] { --size: 2; }
        ul.bottom-nav-cloud li[data-weight="3"] { --size: 3; }
        ul.bottom-nav-cloud li[data-weight="4"] { --size: 4; }
        ul.bottom-nav-cloud li[data-weight="5"] { --size: 5; }
        ul.bottom-nav-cloud li[data-weight="6"] { --size: 6; }
        ul.bottom-nav-cloud li[data-weight="7"] { --size: 7; }
        ul.bottom-nav-cloud li[data-weight="8"] { --size: 8; }
        ul.bottom-nav-cloud li[data-weight="9"] { --size: 9; }
		.tag-communities-container {
			display: none;
		}
        .items-container-sm-screen {
            display: block;
			width: 100%;
        }
        /* carousel ux for mobile */
		.inner {
			display: flex;
			overflow-x: auto;
			scroll-snap-type: x mandatory;
			scroll-behavior: smooth;
			-webkit-overflow-scrolling: touch;
		}
		.section {
			scroll-snap-align: start;
			flex-shrink: 0;
			width: 100%;
			/* margin-right: 50px; */
			/* border-radius: 10px; */
			/* background: #eee; */
			transform-origin: center center;
			transform: scale(1);
			transition: transform 0.5s;
			position: relative;
            background: rgb(30,30,30);
		}
        .feed-bottom-nav {
			position: fixed;
			left: 0;
			bottom: 0;
			right: 0;
			z-index: 999999999;
			display: block;
			width: 100%;
			background-color: black;
			color: #4d4d4d;
			display: flex;
			align-items: center;
			padding: 10px;
		}
		.feed-bottom-nav-inner {
			overflow-x: scroll;
			width: 100%;
		}
		.bottom-nav-cloud {
			list-style: none;
			padding-left: 0;
			display: flex;
			background: rgb(0,0,0);
		}
		ul.bottom-nav-cloud li {
			color: #2a7e19;
			display: block;
			font-size: 1.5rem;
			padding: 0.125rem 0.25rem;
			text-decoration: none;
			position: relative;
			--size: 4;
			opacity: calc((15 - (9 - var(--size))) / 15); 
		}
    }
</style>